export const SET_FORM_LOADING = '@createMV/SET_FORM_LOADING';
export const SET_FORM_DATA = '@createMV/SET_FORM_DATA';
export const SET_MANUFACTURER_ID = '@createMV/SET_MANUFACTURER_ID';
export const SET_VARIANT_ID = '@createMV/SET_VARIANT_ID';
export const SET_OFFER_PRICE = '@createMV/SET_OFFER_PRICE';
export const SET_MRP = '@createMV/SET_MRP';
export const SET_VENDOR_PRICE = '@createMV/SET_VENDOR_PRICE';
export const SET_SUBMIT_LOADING = '@createMV/SET_SUBMIT_LOADING';



// WEBPACK FOOTER //
// ./src/Modules/CreateNewManufacturerVariant/constants.js